import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/check.svg';
import MerchantReinsurance from '~/components/molecules/Product/MerchantReinsurance.vue';
import ProductOffers from '~/components/molecules/Product/ProductOffers.vue';
import USE_MARKETPLACE from '~/const/marketplace';
export default {
  name: 'Reinsurance',
  components: {
    MerchantReinsurance: MerchantReinsurance,
    ProductOffers: ProductOffers
  },
  props: {
    deliveryPayload: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    activeDeliveryPayload: function activeDeliveryPayload() {
      var openStores = ['fr-FR', 'fr-BE', 'nl-BE', 'fr-CH', 'de-CH', 'it-CH', 'de-DE', 'fr-LU', 'it-IT', 'es-ES'];
      return openStores.includes(this.locale.iso);
    },
    merchantUrl: function merchantUrl() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/m/").concat(this.product.offer.merchant.name.toLowerCase(), "-").concat(this.product.offer.merchant.reference);
    },
    returnsUrl: function returnsUrl() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/retour-gratuit.htm");
    },
    homeDeliveryText: function homeDeliveryText() {
      return this.product.marketplace ? this.$t('homeDeliveryWithoutWithdrawal') : this.$t('homeDelivery');
    },
    deliveryUrl: function deliveryUrl() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/statique/livraison.htm");
    },
    isMarketplaceOpen: function isMarketplaceOpen() {
      return USE_MARKETPLACE(this);
    }
  }),
  methods: {
    handleClickMerchant: function handleClickMerchant(event) {
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_vendeur',
          event_label: this.product.offer.merchant.name
        }
      });
    },
    handleClickDelivery: function handleClickDelivery(event) {
      this.$root.$emit('generic-tracking', event, {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_FAQ_Livraison',
          event_label: 'Clic_FAQ_Livraison'
        }
      });
    },
    handleClickReturns: function handleClickReturns(event) {
      this.$root.$emit('generic-tracking', event, {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_FAQ_Retours',
          event_label: 'Clic_FAQ_Retours'
        }
      });
    }
  }
};